import { createUseStyles } from "react-jss";
import LinearProgress from "@mui/material/LinearProgress";
import { Fragment } from "react";
import { Text } from "$components";
import { theme } from "$utils/theme/bataillog";

type Props = {
  currentStep: number;
  steps: string[];
  setStep: (step: number) => void;
  maxStepIndex: number;
};

// eslint-disable-next-line consistent-return
const getValprogressBar = (curStep: number, stepIndex: number) => {
  if (curStep === stepIndex) {
    return 50;
  }
  if (curStep < stepIndex) {
    return 0;
  }
  if (curStep > stepIndex) {
    return 100;
  }
};

function Tunel({ steps, currentStep, setStep, maxStepIndex }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.tunel}>
      <ul className={classes.steps}>
        {steps.map((step, index) => (
          <Fragment key={step}>
            <div
              onClick={() => setStep(index)}
              key={step}
              className={`${classes.step} step ${
                currentStep === index
                  ? "active"
                  : index <= maxStepIndex
                  ? "activable"
                  : ""
              }`}
            >
              <Text
                className={`${classes.stepText} ${
                  currentStep === index
                    ? "active"
                    : index <= maxStepIndex
                    ? "activable"
                    : ""
                }`}
              >
                {step}
              </Text>
            </div>
            {index !== steps.length - 1 && (
              <div className={`progress-bar ${classes.progressBar}`}>
                <LinearProgress
                  variant="buffer"
                  value={getValprogressBar(currentStep, index)}
                  valueBuffer={0}
                />
              </div>
            )}
          </Fragment>
        ))}
      </ul>
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  tunel: {
    "& .MuiLinearProgress-root": {
      height: 2,
    },
    "& .MuiLinearProgress-dashed": {
      animation: "none",
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: `${theme.color.blueLight}`,
    },
    "& .MuiLinearProgress-dashedColorPrimary": {
      backgroundSize: "6px 10px",
      backgroundImage:
        "radial-gradient(rgb(204 205 208) 0%, rgb(204 205 208) 16%, transparent 42%)",
    },
  },
  steps: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    counterReset: "step",
    "& .step": {
      color: `${theme.color.gray5}`,
      fontSize: 15,
      "&:before": {
        counterIncrement: "step",
        content: "counter(step)",
        marginRight: 13,
        width: 32,
        height: 32,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        border: `solid 1px ${theme.color.gray3}`,
        color: `${theme.color.gray5}`,
        borderRadius: "100%",
        fontSize: 18,
      },
    },
    "& .active.step": {
      cursor: "pointer",
      color: `${theme.color.blueLight} !important`,
      "&:before": {
        border: `solid 1px ${theme.color.blueLight}`,
        color: "#fff",
        background: `${theme.color.blueLight}`,
      },
    },
    "& .activable.step": {
      cursor: "pointer",
      color: `${theme.color.blueLight} !important`,
      "&:before": {
        border: `solid 1px ${theme.color.blueLight}`,
        color: "#fff",
        background: `${theme.color.blueLight}`,
      },
    },
  },
  step: {
    display: "flex",
    alignItems: "center",
    "&:last-child .progress-bar": {
      display: "none",
    },
  },
  stepText: {
    color: `${theme.color.gray5}`,
    fontSize: 15,
    "&.active": {
      color: `${theme.color.blueLight}`,
      fontWeight: "bold",
    },
    "&.activable": {
      color: `${theme.color.blueLight}`,
    },
  },
  progressBar: {
    width: 100,
    margin: "0 15px",
  },
  btn: {
    cursor: "pointer",
  },
}));

export default Tunel;
